import { subDays as subDaysFns } from 'date-fns';

export default function subDays(date: Date, days: number): Date {
  return subDaysFns(date, days);
}
